import { useCurrentPageOrNull } from '@dtx-company/inter-app/src/redux/slices/utils'

export function useNextLinkOrder(): number {
  const page = useCurrentPageOrNull()
  return (page?.links?.length || 0) + 1
}
